import * as zod from 'zod';

export default zod.object({
  codeBlockId: zod.string(),
  codeBlockCode: zod.string(),
});
